import { render, staticRenderFns } from "./List-distribution.vue?vue&type=template&id=5141295c"
import script from "./List-distribution.vue?vue&type=script&lang=js"
export * from "./List-distribution.vue?vue&type=script&lang=js"
import style0 from "./List-distribution.vue?vue&type=style&index=0&id=5141295c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports